// extracted by mini-css-extract-plugin
module.exports = {"MenuItem":"MenuItem_MenuItem__295SS","MenuItem_active":"MenuItem_MenuItem_active__2a0GB"};